import { ApiHelper } from '@common/api/apiHelper';
export var apiHelper = new ApiHelper('/api/machineRegistration');
